import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "preferential_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  class: "my_yhj"
};
const _hoisted_4 = {
  class: "my_yhj_t"
};
const _hoisted_5 = {
  class: "lq_yhj"
};
const _hoisted_6 = {
  class: "yhj_list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "item_l",
  style: {
    "zoom": "80%"
  }
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  class: "item_r"
};
const _hoisted_12 = {
  class: "yhj_an"
};
const _hoisted_13 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[2] || (_cache[2] = _createElementVNode("span", null, "领劵中心", -1))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("h2", null, "我的优惠券", -1)), _createElementVNode("span", {
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.go && $setup.go(...args))
  }, "全部" + _toDisplayString($setup.my_cardRecordsList.length) + "张>", 1)])]), _createElementVNode("div", _hoisted_5, [_cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "lqyhjbt"
  }, [_createElementVNode("h2", null, "好券可领")], -1)), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardRecordsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: _normalizeStyle($setup.designsObj[item.cardId]?.background ? 'background:url(' + $setup.designsObj[item.cardId].background + ');background-size:100% 100%;' : ''),
      onClick: $event => item.lock ? $setup.call() : ''
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
      style: _normalizeStyle('color:' + ($setup.designsObj[item.cardId]?.titleColor || '#41B8B2')),
      class: "yhj_text"
    }, [item.cardType != 'discount' ? (_openBlock(), _createElementBlock("span", _hoisted_9, "￥")) : _createCommentVNode("", true), _createElementVNode("h2", null, _toDisplayString(item.cardType != 'discount' ? item.reduceCost : item.discount), 1), item.cardType == 'discount' ? (_openBlock(), _createElementBlock("span", _hoisted_10, "折")) : _createCommentVNode("", true)], 4), _createElementVNode("div", {
      style: _normalizeStyle('background:' + ($setup.designsObj[item.cardId]?.titleColor || '#41B8B2')),
      class: "yhj_lx"
    }, [_createElementVNode("h2", null, _toDisplayString(item.cardType == 'case' ? '满减券' : item.cardType == 'discount' ? '折扣券' : item.cardType == 'cash' ? '抵价券' : '兑换劵'), 1)], 4)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
      class: "yhj_xx",
      style: _normalizeStyle('color' + ($setup.designsObj[item.cardId]?.dateColor || '#000'))
    }, [_createElementVNode("h2", null, _toDisplayString(item.title), 1), _cache[4] || (_cache[4] = _createElementVNode("span", null, "有效期：****", -1))], 4), _createElementVNode("div", _hoisted_12, [!item.lock ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "btn_click",
      onClick: $event => $setup.getCoupon(item.cardId, item),
      style: _normalizeStyle('background:' + (item.unClaimable ? '#999' : $setup.designsObj[item.cardId]?.btnColor || '#41B8B2'))
    }, " 领取 ", 12, _hoisted_13)) : _createCommentVNode("", true)])])], 12, _hoisted_7);
  }), 128))])])]);
}